import Medusa from '@medusajs/medusa-js';
import { QueryClient } from '@tanstack/react-query';
import { CLIENT_API_KEY } from './constants/variants';

// Defaults to standard port for Medusa server
const NEXT_PUBLIC_MEDUSA_BACKEND_URL =
    process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || 'http://localhost:9000';

const HOSTING_ENV = process.env.HOST_ENV || process.env.NEXT_PUBLIC_HOST_ENV || process.env.SENTRY_ENV || process.env.NEXT_PUBLIC_SENTRY_ENV;

//When this is requested on the client, MEDUSA_BACKEND_URL is not populated, so
//the client is given the NEXT_PUBLIC_MEDUSA_BACKEND_URL value
//However, when running serverside, it's given MEDUSA_BACKEND_URL
const MEDUSA_BACKEND_URL =
    process.env.MEDUSA_BACKEND_URL || NEXT_PUBLIC_MEDUSA_BACKEND_URL;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 60 * 24,
            retry: 1,
        },
    },
});

const medusaClient = new Medusa({
    baseUrl: MEDUSA_BACKEND_URL,
    maxRetries: 3,
    customHeaders: {
        'x-api-key': CLIENT_API_KEY,
    },
});

const SEARCH_SERVICE_URL = process.env.NEXT_PUBLIC_SEARCH_SERVICE_URL || '';
const SEARCH_SERVICE_TOKEN = process.env.NEXT_PUBLIC_SEARCH_SERVICE_TOKEN || '';
const REVALIDATE_WINDOW = process.env.NEXT_PUBLIC_REVALIDATE_WINDOW || 60 * 30; // 30 minutes
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

export {
    MEDUSA_BACKEND_URL,
    queryClient,
    medusaClient,
    SEARCH_SERVICE_URL,
    SEARCH_SERVICE_TOKEN,
    REVALIDATE_WINDOW,
    HOSTING_ENV,
    BASE_URL
};
